import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { format,parse,differenceInDays } from 'date-fns';
import addDays from 'date-fns/addDays';
import { Router,ActivatedRoute,ParamMap,NavigationExtras } from "@angular/router";
import * as c3 from 'c3';

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsExcelService
    ,FvmsApiDtgReportCarService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import {
    FilterDist
    ,FilterSecToTime
    ,FilterDateTime
    ,FilterDateDiff
} from "src/app/shared/filter";

@Component({
    selector: "report-car-month-daily"
    ,templateUrl: './dtg.report.car.month.daily.component.html'
    ,providers: [FilterDist,FilterSecToTime,FilterDateTime,FilterDateDiff]
})
export class DtgReportCarMonthDailyComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    listItem:any[] = [];
    pagingInfo:PagingInfo = new PagingInfo();
    excelPagingInfo:PagingInfo = new PagingInfo();
    dateTimeInfo:any;
    @Input() listType:DtgListType = DtgListType.list;
    selectedDate:any;
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    userGroupId:number;
    listYear:number[] = [];
    listMonth:number[] = [];
    dtgUnitId:string = "";
    selectedYear:number = 2020;
    selectedMonth:number = 0;
    minDriveDt:any;
    maxDriveDt:any;
    maxDriveDtCnt:number = 0;

    chartColors:any[] = ['#4fc3f7', '#fb8c00', '#7460ee', '#f62d51', '#20c997', '#2962FF', '#40c4ff', '#2961ff', '#ff821c', '#7e74fb'];
    chart01:any;
    chart02:any;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private activatedRoute: ActivatedRoute
        ,private router: Router
        ,private fvmsExcelService:FvmsExcelService
        ,private fvmsApiDtgReportCarService:FvmsApiDtgReportCarService
        ,private filterSecToTime:FilterSecToTime
        ,private filterDist:FilterDist
        ,private filterDateTime:FilterDateTime
        ,private filterDateDiff:FilterDateDiff
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.pagingInfo.pageSize = 31;
        this.excelPagingInfo.pageSize = 60*60*24;

        this.dtgUnitId = this.activatedRoute.snapshot.params.dtgUnitId;
        this.selectedYear = this.activatedRoute.snapshot.params.searchYy * 1;
        this.selectedMonth = this.activatedRoute.snapshot.params.searchMm * 1;

        for(let a=2020;a<2100;a++){
            this.listYear.push(a);
        }
        for(let a=1;a<13;a++){
            this.listMonth.push(a);
        }
        let today = new Date();
        if(!this.selectedMonth){
            this.selectedMonth = today.getMonth() + 1;
        }

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                if(companyInfo && this.companyInfo){
                    if(this.companyInfo.companyId !== companyInfo.companyId){
                        //회사가 바뀌면 차량 목록이 다르므로 메인 페이지로 이동해야 함
                        let tmpParam = {
                            runtime:new Date().getTime()
                        };
                        let navigationExtras:NavigationExtras = {
                            queryParams:tmpParam
                        };
                        this.router.navigate(["/dtg/report/car/month/main"],navigationExtras);
                    }
                }else{
                    this.companyInfo = companyInfo;
                }
                this.changeDate();
                this.reloadListItem();
            });
     }

    ngOnInit() {
        this.changeDate();
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    getSearchInfo(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        let searchInfo = {
            companyId:this.companyInfo.companyId || 0
            ,dtgUnitId:this.dtgUnitId
            ,searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
            ,dtgGroupByRegDtYy:"Y"
            ,dtgGroupByRegDtMm:"Y"
            ,dtgGroupByRegDtDd:"Y"
        };
        return searchInfo;
    }

    reloadListItem(){
        this.fvmsCommonService.setIsLoading(true);
        this.maxDriveDtCnt = 0;
        this.minDriveDt = null;
        this.maxDriveDt = null;
        this.fvmsApiDtgReportCarService.getListReportCar(this.getSearchInfo(),this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                this.listItem = []
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        this.listItem = apiResponse.resultValue;
                        let size = this.listItem.length;
                        let dtgRegDtDurationSum = 0;
                        let dtgDistAccumulSum = 0;
                        for(let a=0;a<size;a++){
                            let item = this.listItem[a];
                            if(!this.minDriveDt){
                                this.minDriveDt = parse(item.dtgRegDtFrom,'yyyy-MM-dd HH:mm:ss',new Date());
                                this.minDriveDt.setHours(0);
                                this.minDriveDt.setMinutes(0);
                                this.minDriveDt.setSeconds(0);
                                this.minDriveDt.setMilliseconds(0);
                            }
                            if(!this.maxDriveDt){
                                this.maxDriveDt = parse(item.dtgRegDtFrom,'yyyy-MM-dd HH:mm:ss',new Date());
                                this.maxDriveDt.setHours(0);
                                this.maxDriveDt.setMinutes(0);
                                this.maxDriveDt.setSeconds(0);
                                this.maxDriveDt.setMilliseconds(0);
                            }
                            let currDriveDt = parse(item.dtgRegDtFrom,'yyyy-MM-dd HH:mm:ss',new Date());
                            currDriveDt.setHours(0);
                            currDriveDt.setMinutes(0);
                            currDriveDt.setSeconds(0);
                            currDriveDt.setMilliseconds(0);

                            if(differenceInDays(currDriveDt,this.maxDriveDt) >= 0){
                                this.maxDriveDt = currDriveDt;
                            }
                            if(differenceInDays(this.minDriveDt,currDriveDt) >= 0){
                                this.minDriveDt = currDriveDt;
                            }

                            item.dtgDistAccumulK = item.dtgDistAccumul * 0.001;
                            item.dtgRegDtDurationK = this.filterSecToTime.transform(item.dtgRegDtDuration,"HH:mm:ss")
                            item.dtgRegDtFromK = this.filterDateTime.transform(item.dtgRegDtFrom,'yyyy-MM-dd');
                            dtgRegDtDurationSum += item.dtgRegDtDuration;
                            dtgDistAccumulSum += item.dtgDistAccumul;

                            if(a === 0){
                                let title = `${item.dtgCarNo} 의 운행일지`;
                                // console.log("reloadListItem",title);
                                let routeData = this.activatedRoute.snapshot.data;
                                routeData.title = title;
                            }
                        }
                        this.maxDriveDtCnt = differenceInDays(this.maxDriveDt,this.minDriveDt) + 1;
                        // console.log("avg",this.maxDriveDtCnt,this.maxDriveDt,this.minDriveDt);

                        for(let a=0;a<size;a++){
                            let item = this.listItem[a];
                            item.dtgRegDtDurationSum = dtgRegDtDurationSum;
                            item.dtgDistAccumulSum = dtgDistAccumulSum;
                            item.dtgDistAccumulAvg = Math.floor((dtgDistAccumulSum * 0.001) / this.maxDriveDtCnt);
                            item.dtgRegDtDurationAvg = Math.floor(dtgRegDtDurationSum / this.maxDriveDtCnt);
                            item.dtgRegDtDurationAvgK = this.filterSecToTime.transform(item.dtgRegDtDurationAvg,"HH:mm:ss")
                        }
                        this.initChart01();
                        this.initChart02();
                    }
                    this.pagingInfo = apiResponse.pagingInfo;
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    clickSearch(){
        this.reloadListItem();
    }

    changeDate(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        this.selectedDate = {
            searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
        };
    }

    changeYear(e){
        this.changeDate();
        this.clickSearch();
    }

    changeMonth(e){
        this.changeDate();
        this.clickSearch();
    }

    callbackClickPageNumber(selectedPage:number){
        this.pagingInfo.curPage = selectedPage;
        this.clickSearch();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.clickSearch();
    }

    initChart01(){
        let self = this;
        this.chart01 = c3.generate({
            bindto: '#chart-01'
            ,data: {
                json:this.listItem
                ,keys:{
                    x:"dtgRegDtFromK"
                    ,value:[
                        "dtgRegDtDuration"
                        ,"dtgRegDtDurationAvg"
                    ]
                }
                ,types:{
                    dtgRegDtDuration:"bar"
                    ,dtgRegDtDurationAvg:"line"
                }
                ,names:{
                    dtgRegDtDuration:"운행시간"
                    ,dtgRegDtDurationAvg:"평균운행시간"
                }
                ,onclick:(d,el) => {
                    console.log("click",d.id,d.value);
                }
                ,onmouseover:(d) => {
                }
            }
            ,axis:{
                x:{
                    type:"category"
                    ,show: false
                }
                ,y:{
                    tick: {
                        format: function(y){
                            return self.filterSecToTime.transform(y,"HH:mm:ss");
                        }
                    }
                }
            }
            ,bar: {
                
            }
            ,tooltip:{
                format:{
                    title: function(x,idx){
                        return null;
                    }
                    ,name:function(name, ratio, id, idx){
                        // console.log("tooltip",name, ratio, id, idx);
                        return self.listItem[idx].dtgRegDtFromK;
                    }
                }
            }
        });
    }

    initChart02(){
        let self = this;
        this.chart02 = c3.generate({
            bindto: '#chart-02'
            ,data: {
                json:this.listItem
                ,keys:{
                    x:"dtgRegDtFromK"
                    ,value:[
                        "dtgDistAccumulK"
                        ,"dtgDistAccumulAvg"
                    ]
                }
                ,types:{
                    dtgDistAccumulK:"bar"
                    ,dtgDistAccumulAvg:"line"
                }
                ,names:{
                    dtgDistAccumulK:"운행거리"
                    ,dtgDistAccumulAvg:"평균운행거리"
                }
                ,onclick:(d,el) => {
                    console.log("click",d.id,d.value);
                }
                ,onmouseover:(d) => {
                }
            }
            ,axis:{
                x:{
                    type:"category"
                    ,show: false
                }
                ,y:{
                    tick: {
                        format: function(y){
                            return `${y} km`;
                        }
                    }
                }
            }
            ,bar: {
                
            }
            ,tooltip:{
                format:{
                    title: function(x,idx){
                        return null;
                    }
                    ,name:function(name, ratio, id, idx){
                        // console.log("tooltip",name, ratio, id, idx);
                        return self.listItem[idx].dtgRegDtFromK;
                    }
                }
            }
        });
    }

    exportExcel(){
        this.fvmsCommonService.setIsLoading(true);
        this.fvmsApiDtgReportCarService.getListReportCar(this.getSearchInfo(),this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        let fileName = "report-car-month-daily-" + new Date().valueOf();
                        this.fvmsExcelService.excelDownload(this.convertExcelJson(apiResponse.resultValue),fileName);
                    }
                    this.pagingInfo = apiResponse.pagingInfo;
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    convertExcelJson(dataList:any[]){
        let resultList = [];
        dataList.map((v,idx) => {
            // console.log(v);
            resultList.push({
                "순번":idx+1
                ,"차량번호":v.dtgCarNo
                ,"운행일시":this.filterDateTime.transform(v.dtgRegDtFrom,"yyyy-MM-dd")
                ,"운행시간":this.filterSecToTime.transform(v.dtgRegDtDuration,"HH:mm:ss")
                ,"운행거리(km)":this.filterDist.transform(Number(v.dtgDistAccumul))
                ,"트립건수":v.dtgDriveTripCnt
            })
        });
        return resultList;
    }
}